import type { TFunction } from 'i18next'
import { TimeTrackingApproval } from '@/api/model'

/** Translated label of an approval state (`timetracking.status.<Enum>`). */
export function getTimeTrackingStatusLabel(t: TFunction, status: TimeTrackingApproval): string {
  return t(`timetracking.status.${status}`)
}

/** Badge color classes per approval state (analogous to the absences). */
export const TIMETRACKING_STATUS_CLASS: Record<TimeTrackingApproval, string> = {
  [TimeTrackingApproval.Pending]: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  [TimeTrackingApproval.Approved]: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300',
  [TimeTrackingApproval.Rejected]: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
  [TimeTrackingApproval.Invalid]: 'bg-muted text-muted-foreground',
}
